import script from "./ConfirmationFormContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationFormContainer.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__